import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-xxl border-0" }
const _hoisted_2 = { class: "d-flex d-xl-none flex-row w-100 overflow-auto" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "d-none d-xl-flex flex-column col-2 col-xl-12" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navs, (nav, i) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["nav-link rounded py-2 px-3 mt-1 flex-shrink-0", { active: _ctx.active === nav.id }]),
          "aria-current": "page",
          onClick: ($event: any) => (_ctx.$emit('changeActive', nav.id)),
          style: {"cursor":"pointer"},
          key: nav.id + i
        }, [
          (nav.icon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(nav.icon)
              }, null, 2))
            : _createCommentVNode("", true)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navs, (nav, i) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["nav-link rounded py-2 mt-1", { active: _ctx.active === nav.id }]),
          "aria-current": "page",
          onClick: ($event: any) => (_ctx.$emit('changeActive', nav.id)),
          style: {"cursor":"pointer"},
          key: nav.id + i
        }, [
          (nav.icon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass([nav.icon, "d-none d-xl-inline"])
              }, null, 2))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$getLocale(nav.name)), 1)
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}